import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', service: '', message: '' });
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-header">
          <h2 className="section-title">Let's Start a Conversation</h2>
          <p className="section-subtitle">
            Have a project in mind? We'd love to hear about it. Fill out the form and our team will reach out to discuss how we can help bring your vision to life.
          </p>
        </div>
        
        <div className="contact-form-wrapper">
          <div className="form-left-panel">
            <div className="panel-content">
              <h3>Why Choose Us?</h3>
              <div className="benefit-list">
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Expert Team</h4>
                    <p>Experienced professionals dedicated to your success</p>
                  </div>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Fast Response</h4>
                    <p>We respond to all inquiries within 24 hours</p>
                  </div>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Transparent Pricing</h4>
                    <p>No hidden fees, clear and fair pricing structure</p>
                  </div>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Quality Assured</h4>
                    <p>Delivering excellence in every project we undertake</p>
                  </div>
                </div>
              </div>
              
              <div className="panel-stats">
                <div className="stat-item">
                  <span className="stat-value">150+</span>
                  <span className="stat-label">Projects Delivered</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">98%</span>
                  <span className="stat-label">Client Satisfaction</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">24/7</span>
                  <span className="stat-label">Support Available</span>
                </div>
              </div>
            </div>
          </div>

          <form className="contact-form-new" onSubmit={handleSubmit}>
            <div className="form-header-new">
              <h3>Get Started Today</h3>
              <p>Tell us about your project and we'll get back to you shortly</p>
            </div>

            <div className="form-grid">
              <div className={`form-field ${formData.name ? 'has-value' : ''}`}>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder=" "
                />
                <label htmlFor="name">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 8a3 3 0 100-6 3 3 0 000 6zM8 9c-3 0-6 1.5-6 3.5V14h12v-1.5c0-2-3-3.5-6-3.5z" fill="currentColor"/>
                  </svg>
                  Full Name
                </label>
              </div>

              <div className={`form-field ${formData.email ? 'has-value' : ''}`}>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder=" "
                />
                <label htmlFor="email">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 4h12v8H2V4zm0 0l6 4 6-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Email Address
                </label>
              </div>

              <div className={`form-field ${formData.phone ? 'has-value' : ''}`}>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder=" "
                />
                <label htmlFor="phone">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 11v2c0 1-1 1-1 1-7 0-11-4-11-11 0 0 0-1 1-1h2c1 0 1 0 1 1v2c0 1 0 1-1 1 0 0 0 1 1 1 1 2 2 3 4 4 0 0 1 0 1-1 0 0 0-1 1-1h2c1 0 1 0 1 1z" fill="currentColor"/>
                  </svg>
                  Phone Number
                </label>
              </div>

              <div className={`form-field ${formData.service ? 'has-value' : ''}`}>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value=""></option>
                  <option value="web-development">Web Development</option>
                  <option value="ai-solutions">AI Solutions</option>
                  <option value="data-engineering">Data Engineering</option>
                  <option value="design-engineering">Design/Engineering</option>
                  <option value="digital-marketing">Digital Marketing</option>
                  <option value="other">Other Services</option>
                </select>
                <label htmlFor="service">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 5h12M2 8h12M2 11h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                  Service Interested In
                </label>
              </div>
            </div>

            <div className={`form-field form-field-full ${formData.message ? 'has-value' : ''}`}>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder=" "
              ></textarea>
              <label htmlFor="message">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H2v10h3v2l3-2h6V2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Tell us about your project
              </label>
            </div>

            <button type="submit" className="btn-submit-new">
              <span>Send Message</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 10h14M13 4l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
